import {Component, Prop, Vue} from "vue-property-decorator";
import {DataTable} from "~/components/data-table";
import {getUsersManagementStore} from "~/modules/users/store";

const usersManagementStore = getUsersManagementStore();

@Component
export class UsersRolesList extends Vue {

  @usersManagementStore.State rolesConfig;

  get headers() {
    return [
      {
        key: 'role',
        value: config => config.role.label, label: "Role"
      },
      {
        key: 'count',
        value: config => config.meta.usersCount,
        label: "Nombre d'utilisateurs"
      },
      {
        key: 'maxUsers',
        value: config => config.maxUsers === -1 ? "Illimité": config.maxUsers,
        label: "Nombe maximum d'utilisateurs"
      }
    ];
  }

  render() {
    return (
      <div class="roles-list">
        <DataTable headers={this.headers} tableData={this.rolesConfig}/>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-93e2abf2/roles-list.tsx" });